<script setup>
import { ref, watch, onMounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['update:visible']);;

const user = ref();
const localVisible = ref(props.visible);

async function handleShow() {
  user.value = JSON.parse(localStorage.getItem('user'));
}

function handleHide() {
  emit('update:visible', false);
}

const extensions = ref([{
  name: 'Chrome',
  url: 'https://lc.cx/chrome-extension'
}, {
  name: 'Firefox',
  url: 'https://lc.cx/firefox-extension'
}, {
  name: 'Edge',
  url: 'https://lc.cx/edge-extension'
}]);

watch(
  () => props.visible,
  (newValue) => {
    localVisible.value = newValue;
  }
)
</script>


<template>
  <Dialog @hide="handleHide" @show="handleShow" v-model:visible="localVisible" modal header="Extensions"
    :style="{ width: '25rem' }">
    <div class="mb-8">
      <DataTable :value="extensions">
        <Column field="name" :header="t('extensions.name')"></Column>
        <Column field="download" :header="t('common.labels.download')">
          <template #body="slotProps">
            <Button as="a" size="small" icon="pi pi-download" :href="slotProps.data.url" target="_blank" />
          </template>
        </Column>
      </DataTable>
    </div>
    <div class="flex justify-end gap-2">
      <Button type="button" :label="t('common.labels.close')" severity="secondary" @click="handleHide"></Button>
    </div>
  </Dialog>
</template>
